<!-- Container que decide qué versión renderizar según el flujo -->
<section class="section section--simulation">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main flexColumn">
          <article class="mainInfo flexChild--static pb-25">
            <h1 class="pb-10">Simulador de crédito</h1>
            <p>Ingresá el <strong>monto</strong> que deseas solicitar y seleccioná el <strong>plazo de pago</strong> para calcular tus cuotas.</p>
          </article>

          <article class="simulatorContent flexChild--flexible">
            <app-sales-simulator-kredicash-v3-version-v3
              *ngIf="isFlowKrdya"
              (nextStepEvent)="onNextStep()">
            </app-sales-simulator-kredicash-v3-version-v3>

            <app-sales-simulator-kredicash-v3-version-v2
              *ngIf="!isFlowKrdya"
              (nextStepEvent)="onNextStep()">
            </app-sales-simulator-kredicash-v3-version-v2>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>
